import { Row } from 'src/components/atoms/Row';
import styled, { css } from 'styled-components';

export const StyledDiv = styled.div`
  @media ${({ theme }) => theme.device.xs}, ${({ theme }) => theme.device.mobile} {
    width: 50%;
  }
`;

const filterControl = css`
  @media ${({ theme }) => theme.device.xs}, ${({ theme }) => theme.device.mobile} {
    width: 50%;
    flex: 0 0 50%;
  }
`;

/** The search box is the only control that shrinks, so it needs a floor. */
export const StyledSearch = styled.div`
  flex: 1 1 18rem;
  min-width: 14rem;

  @media ${({ theme }) => theme.device.xs}, ${({ theme }) => theme.device.mobile} {
    width: 100%;
    flex: 1 1 100%;
  }
`;

export const StyledStatusFilter = styled.div`
  width: 10rem;
  flex: 0 0 10rem;
  ${filterControl}

  /* Match the search box and the Add property button so the toolbar lines up. */
  .DDSubContainer {
    height: 2.75rem;
  }
`;

export const StyledCompanyFilter = styled.div`
  width: 100%;
  flex: 1 1 100%;
  ${filterControl}

  .DDSubContainer {
    height: 3rem;
  }

  /* The shared multicheck wraps its chips onto new lines, which fights the fixed
     height. Keep them on one line and scroll sideways instead. The only div
     inside the button's content is the chip container. */
  .DDContent div {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .DDContent span {
    flex-shrink: 0;
  }
`;

export const StyledRow = styled(Row)`
  @media ${({ theme }) => theme.device.tablet} {
    flex-direction: column;
    margin-left: 0.625rem;
  }
`;
